import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { toApiError } from '@pharvio/core/shared';
import { BUILD_INFO } from '../../../environments/build-info';

/**
 * Normalises every HTTP failure into an `ApiError` (unwrapping the
 * `{ success: false, error }` envelope so `code` is preserved).
 *
 * 401 handling — refresh once, retry, else sign out — lives in the shared
 * `authSessionInterceptor`, not here.
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    catchError((errorResponse: unknown) =>
      throwError(() => ({
        ...toApiError(errorResponse, req.url),
        clientVersion: `${BUILD_INFO.version}+${BUILD_INFO.commit}`
      }))
    )
  );
